<template>
  <div>
    <h2 class="bb-page-title">Position List</h2>
    <div class="bb-positions-settings">
      <div class="bb-positions-settings-item">
        <h3 class="bb-positions-settings-item-title">
          <span class="bb-positions-settings-item-title__number">1</span>
          Departments
        </h3>
        <Departments/>
      </div>
      <transition name="fade">
        <div class="bb-positions-settings-item" v-if="departmentsList && departmentsList.length > 0">
          <h3 class="bb-positions-settings-item-title">
            <span class="bb-positions-settings-item-title__number">2</span>
            Create position
          </h3>
          <Positions/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Positions from '@/components/Settings/PositionsList/Positions/Positions'
import Departments from '@/components/Settings/PositionsList/Departments/Departments'

export default {
  name: 'SettingsPositionsList',
  components: {
    Positions,
    Departments
  },
  computed: {
    departmentsList () {
      return this.$store.getters.departmentsList
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-positions-settings {
    @include global-font;
    display: flex;

    &-item {
      margin-top: 27px;
      flex-basis: 50%;

      &-title {
        display: flex;
        align-items: center;
        margin-bottom: 21px;
        color: $color-accent;
        font-weight: 600;
        font-size: 18px;
        line-height: 21px;

        &__number {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 13px;
          color: $color-white;
          background-color: $color-accent;
          border-radius: 50%;
          width: 25px;
          height: 25px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/PositionsList/PositionsList.vue